// driving_school_classroom_type_setup_controller.js
import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "locationTypeInPerson",
    "locationTypeRemote",
    "locationTypeOptionInPerson",
    "locationTypeOptionRemote",
    "locationTypeOptionBoth",
    "gapBetweenSessions"
  ]

  updateSessionsPerDay(event) {
    const sessionsPerDay = Number(event.target.value);
    const showGapField = Number.isInteger(sessionsPerDay) && sessionsPerDay > 1;
    
    this.gapBetweenSessionsTarget.classList.toggle("u-hidden", !showGapField);
  }

  updateLocationType() {
    if (this.locationTypeOptionInPersonTarget.checked) {
      this.locationTypeInPersonTarget.classList.remove("u-hidden");
      this.locationTypeRemoteTarget.classList.add("u-hidden");
    }

    if (this.locationTypeOptionRemoteTarget.checked) {
      this.locationTypeInPersonTarget.classList.add("u-hidden");
      this.locationTypeRemoteTarget.classList.remove("u-hidden");
    }

    if (this.locationTypeOptionBothTarget.checked) {
      this.locationTypeInPersonTarget.classList.remove("u-hidden");
      this.locationTypeRemoteTarget.classList.remove("u-hidden");
    }
  }

  validate(event) {
    const errors = this.validateForm();
    
    if (errors.length > 0) {
      event.preventDefault();
      this.showValidationBlock(errors.join("<br>"));
      return;
    }    
  }

  validateForm() {
    let validationErrors = [];

    let fieldsToValidate = [
      { id: "driving_school_classroom_type_name", 
        name: "Name", 
        validation: "required" 
      },
      { id: "driving_school_classroom_type_number_of_sessions", 
        name: "Total sessions", 
        validation: "required|positiveNumber" 
      },
      { id: "driving_school_classroom_type_number_of_sessions_per_day", 
        name: "Sessions per day", 
        validation: "required|positiveNumber" 
      },
      { 
        id: "driving_school_classroom_type_gap_between_sessions_in_minutes", 
        name: "Session gap (mins)", 
        hidden: this.gapBetweenSessionsTarget.classList.contains('u-hidden'),
        validation: "required|positiveNumber" 
      },
      { 
        id: "driving_school_classroom_type_max_number_of_in_person_attendees", 
        name: "Max attendees", 
        hidden: this.locationTypeInPersonTarget.classList.contains('u-hidden'), 
        validation: "required|positiveNumber" 
      },
      { 
        id: "driving_school_classroom_type_max_number_of_remote_attendees", 
        name: "Max remote attendees", 
        hidden: this.locationTypeRemoteTarget.classList.contains('u-hidden'), 
        validation: "required|positiveNumber" 
      },
      { type: "coursework" }
    ];

    fieldsToValidate.forEach(field_data => {
      if (!field_data.hidden) {
        if (field_data.type === "coursework") {
          validationErrors.push(...this.validateCoursework());
        } else {
          let field = document.getElementById(field_data.id);
          
          if (field) {
            let value = field.value;
            let validationRules = field_data.validation.split('|');
      
            for (let rule of validationRules) {
              switch (rule) {
                case 'required':
                  if (!value) {
                    validationErrors.push(`${field_data.name} is required.`);
                    return;
                  }
                  break;
      
                case 'positiveNumber':
                  if (value === "") {
                    validationErrors.push(`${field_data.name} cannot be empty.`);
                    return;
                  } else if (isNaN(value) || Number(value) <= 0) {
                    validationErrors.push(`${field_data.name} must be greater than 0.`);
                    return;
                  }
                  break;
              }
            }
          }
        }
      }
    });
    
    return validationErrors;
  }

  validateCoursework() {
    const errors = [];

    const rows = document.querySelectorAll(
      '[data-controller="add-to-form"] [data-add-to-form-target="container"] [data-add-to-form-target="row"]'
    );

    let total = 0;
    let anyCompletedItem = false;

    rows.forEach((row, index) => {
      const nameInput = row.querySelector('input[name$="[name]"]');
      const weightInput = row.querySelector('input[name$="[weight]"]');

      const nameValue = (nameInput?.value || "").trim();
      const weightValue = (weightInput?.value || "").trim();

      const namePresent = nameValue.length > 0;
      const weightPresent = weightValue.length > 0;

      if (!namePresent && !weightPresent) return;

      if (namePresent && !weightPresent) {
        errors.push(`Coursework item ${index + 1} must have a weight.`);
      }

      if (weightPresent && !namePresent) {
        errors.push(`Coursework item ${index + 1} must have a name.`);
      }

      // Both present: validate numeric weight and contribute to total
      const weight = Number(weightValue);
      if (Number.isNaN(weight)) {
        errors.push(`Coursework item ${index + 1} weight must be a number.`);
      }

      anyCompletedItem = true;
      total += weight;
    });

    // If no completed coursework at all, coursework is optional: skip the 100% rule
    if (!anyCompletedItem) return errors;

    // Otherwise, weights must total 100%
    const rounded = Math.round(total * 100) / 100;
    if (rounded !== 100) {
      errors.push(`Coursework weights must total 100% (currently ${rounded}%).`);
    }

    return errors;
  }

  showValidationBlock(message) {
    const validationBlock = document.getElementById("validation-block");
    const validationMessage = document.getElementById("validation-message");
  
    validationMessage.innerHTML = message;
    validationBlock.hidden = false;
    validationMessage.hidden = false;
  }
}

